import { doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from './firebase.js';
import {BlogBanner, EventBanner, EventResources, PicLink, Prompt, Quicklink, ScrollReset} from './obj';
import dmoj from './icons/dmoj_white.png';
import vjudge from './icons/vjudge.svg';
import help from './icons/material-symbols_help-outline.svg';
import article from './icons/material-symbols_article-outline.svg'
export default function BlogEntry() {
	const [data, setData] = useState(null);
	const [exists, setExists] = useState(true);
	const {blogId} = useParams();
	useEffect(() => {
		let mounted = true;
		async function loadBlog() {
			// Get blog data
			const docRef = doc(db, 'blogs', blogId);
			const docSnap = await getDoc(docRef);
			if (!mounted) return;
			if (!docSnap.exists()) {
				setExists(false);
				return;
			}
			setData(docSnap.data());
		}
		loadBlog();
		return () => {
			mounted = false;
		};
	}, [blogId]);

	if (!exists) return <>This blog does not exist.</>;
	if (data === null) return <>Loading...</>;
	const dateStr = data?.date?.toDate
		? data.date.toDate().toDateString()
		: '';
	return (
		<>
			<main className = "eventpage">
				<ScrollReset/>
				<BlogBanner title = {data.topic} date={dateStr}></BlogBanner>
				<section className= "twocol">
					{data.recordingLinks && <EventResources title = "LECTURE">
						{data.recordingLinks.map((link, idx) => (

							<div className="responsive-16by9" key={idx}>
								<iframe
									title={`recording-${idx}`}
									src={link}
									allowFullScreen
									loading="lazy"
								></iframe>
							</div>
						))}
					</EventResources>}

					<EventResources title="RESOURCES">
						{data.problemsetLink && <Quicklink src = { data.problemsetLink.includes("judge.monashaps") ? (dmoj) : (data.problemsetLink.includes("vjudge") ? (vjudge) : (help))} path = {data.problemsetLink}>
							Problem set
						</Quicklink>}
						{data.slideLink && <Quicklink src = {article} path = {data.slideLink}>Slides</Quicklink> }
					</EventResources>

				</section>
				{data.slideLink && <section>
					<EventResources title= "PRESENTATION">
								<div className="responsive-16by9">
									<iframe
										title="slides"
										src={data.slideLink}
										loading="lazy"
									></iframe>
								</div>
					</EventResources>
				</section>}
				<section>


				</section>

			</main>
		</>
	);
}
